import React, { Component } from "react";
import TrainingZoneButton from './TrainingZoneButton.jsx';
// import { abs } from 'mathjs';
import RangeSlider from './RangeSlider.js'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../index.css';
//import { CircularProgressbar  } from 'react-circular-progressbar';
//import 'react-circular-progressbar/dist/styles.css';



function CustomTextProgressbar(props) {
    const { loadValue, minValue, maxValue } = props;

    return (
        <div
            style={{
                position: 'relative',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '200px',
                height: '200px',
            }}
        >
            <div style={{ position: 'absolute' }}>
                <CircularProgressbar
                    value={loadValue}
                    //minValue={this.getLoadValue(this.props.minSliderValue)}
                    //maxValue={this.getLoadValue(this.props.maxSliderValue)}
                    minValue={minValue}
                    maxValue={maxValue} />
            </div>
            <div
                style={{
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {props.children}
            </div>
        </div>
    );
}

export default class PrescribeTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trainingButtons: ['Technical Competency', 'Speed Strength', 'Power', 'Strength Speed'],
        };

        this.handleSliderChange = this.handleSliderChange.bind(this);
        this.renderTrainingButtonRow = this.renderTrainingButtonRow.bind(this);
        this.renderTrainingButton = this.renderTrainingButton.bind(this);
        this.setMinMaxTrainingZone = this.setMinMaxTrainingZone.bind(this);
        this.getTextForProgressBar = this.getTextForProgressBar.bind(this);
        this.getMinValueForLoad = this.getMinValueForLoad.bind(this);
    }


    getMarks() {
        const marks =
            [
                {
                    value: this.props.minSliderValue,
                    label: [this.props.minSliderValue + "%"],
                },
                //{
                //    value: this.props.secondTickValue,
                //    label: this.props.secondTickValue,
                //},
                //{
                //    value: this.props.thirdTickValue,
                //    label: this.props.thirdTickValue,
                //},
                //{
                //    value: this.props.fourthTickValue,
                //    label: this.props.fourthTickValue,
                //},
                {
                    value: this.props.maxSliderValue,
                    label: [this.props.maxSliderValue + "%"],
                }
            ];
        return (marks)
    }

    handleSliderChange(event, value) {
        this.props.settingStateInParent(value, "currentSliderValue");
    }

    renderTrainingButtonRow = () => {
        const togglePullPush = this.props.togglePullPush;
        if (togglePullPush) {
            return (
                <div >
                    <div className="trainingZoneButtons-row">
                        {this.renderTrainingButton(0)}
                        {this.renderTrainingButton(1)}
                    </div>
                    <div className="trainingZoneButtons-row">
                        {this.renderTrainingButton(2)}
                        {this.renderTrainingButton(3)}
                    </div>
                </div>);
        }
        else {
            return (
                <div className="trainingZoneButtons-row">
                    {this.renderTrainingButton(1)}
                    {this.renderTrainingButton(2)}
                    {this.renderTrainingButton(3)}
                </div>);
        }
    }


    renderTrainingButton(i) {
        const buttonNameStrings = this.state.trainingButtons;
        return (
            <TrainingZoneButton
                text={buttonNameStrings[i]}
                classNameProp={this.props.trainingButtonCurrentClasses[i]}
                colorProps={this.props.trainingButtonCurrentColors[i]}
                onClick={() => this.handleClick(i)}
            />
        );
    }

    handleClick(i) {
        const buttonNameStrings = this.state.trainingButtons;
        const trainingButtonCurrentClasses = ['trainingZoneButtonBlue', 'trainingZoneButtonGreen', 'trainingZoneButtonYellow', 'trainingZoneButtonRed']; // default button classNames without focus
        const trainingButtonClassesOnFocus = ['trainingZoneButtonBlueFocus', 'trainingZoneButtonGreenFocus', 'trainingZoneButtonYellowFocus', 'trainingZoneButtonRedFocus']; // default button classNames without focus
        const trainingButtonCurrentColors = ['#555555', '#555555', '#555555', '#555555'];
        const trainingButtonColorsOnFocus = ['#558bf0', '#52de52', '#dbd61e', '#f14646'];

        var activeZone

        // set active training zone in states based on which one was clicked
        activeZone = buttonNameStrings[i];

        this.props.settingStateInParent(activeZone, "defaultActiveTrainingZone");
        // set the className of the active button to be the focus class name (can expand in future and make button specific focus classNames)
        trainingButtonCurrentClasses[i] = trainingButtonClassesOnFocus[i];
        trainingButtonCurrentColors[i] = trainingButtonColorsOnFocus[i];
        this.props.settingStateInParent(trainingButtonCurrentClasses, "trainingButtonCurrentClasses");
        this.props.settingStateInParent(trainingButtonCurrentColors, "trainingButtonCurrentColors");

        // set the min, max and step values of the slider range based on the training zone selected
        this.setMinMaxTrainingZone(activeZone)
    }

    setMinMaxTrainingZone(activeZone) {
        var min, max, currentValue, explanation = []
        switch (activeZone) {
            case 'Technical Competency':
                min = 0;
                max = 10;
                currentValue = 5;
                explanation = "Add resistance with minimal disruption to sprint mechanics";
                break;
            case 'Speed Strength':
                min = 11;
                max = 39;
                currentValue = 25;
                explanation = "Improve force production capability during transition to Vmax";
                break;
            case 'Power':
                min = 40;
                max = 59;
                currentValue = 50;
                explanation = "Improve force production capability during late acceleration phase ";
                break;
            case 'Strength Speed':
                min = 60;
                max = 100;
                currentValue = 75;
                explanation = "Improve force production capability during initial acceleration";
                break;
            default:
                break;
        }

        // set states for min, max and current value of slider in parent component
        this.props.settingStateInParent(min, "minSliderValue");
        this.props.settingStateInParent(max, "maxSliderValue");
        this.props.settingStateInParent(currentValue, "currentSliderValue");
        this.props.settingStateInParent(explanation, "explanation");

        // calculate values of evenly spaced tick marks
        const sizeOfIncrement = (max - min) / 4; // with five ticks, there are four time it increments from zero to 100% of the slider range
        const secondTick = sizeOfIncrement + min;
        const thirdTick = sizeOfIncrement * 2 + min;
        const fourthTick = sizeOfIncrement * 3 + min;

        // set states for min, max and current value of slider in parent component
        this.props.settingStateInParent(secondTick, "secondTickValue");
        this.props.settingStateInParent(thirdTick, "thirdTickValue");
        this.props.settingStateInParent(fourthTick, "fourthTickValue");
    }

    getLoadValue(currentPercentageSelection) {
        const { slopeValue, interceptValue, vMPS0 } = this.props;
        var { loadValueKg, percentageValue } = [];
        percentageValue = (100 - currentPercentageSelection) / 100;
        if (slopeValue === 0) {
            loadValueKg = 0; // will result in a zero load, with an invalid text message
        }
        else {
            loadValueKg = (percentageValue * Number(vMPS0).toFixed(6) - Number(interceptValue).toFixed(6)) / Number(slopeValue).toFixed(6);
        }
        return loadValueKg
    }

    getTextForProgressBar(loadValue) {
        const { slopeValue } = this.props;
        var text = [];
        if (loadValue < 0 || slopeValue === 0) {
            text = 'Check Input'
        }
        else {
            text = Number(loadValue).toFixed(1)
        }
        return (text)
    }


    getMinValueForLoad() {
        const togglePullPush = this.props.togglePullPush;
        var min = [];
        if (togglePullPush) {
            min = 0

        }
        else {
            min = 11

        }
        return (min)
    }

    render() {
        return (
            <div>
                <h3 className="heading3">Step 3 - Prescribe : Determine optimal sled load for targeted zone of training</h3>
                {this.renderTrainingButtonRow()}
                <h3 className="explanation">{'"' + this.props.explanation + '" - Cahill et al. 2020'}</h3>
                <p className="currentScaleValue">{parseFloat(this.props.currentSliderValue).toFixed(2) + "% velocity decrement"}</p>
                < RangeSlider
                    min={this.props.minSliderValue}
                    max={this.props.maxSliderValue}
                    value={this.props.currentSliderValue}
                    onChange={this.handleSliderChange}
                    valueLabelDisplay={'off'}
                    step={0.5}
                    marks={this.getMarks()}
                    trackOn={"normal"}
                > </RangeSlider>
                <div className="circularBarContainer">
                    <CustomTextProgressbar
                        //minValue={this.getLoadValue(this.props.minSliderValue)}
                        //maxValue={this.getLoadValue(this.props.maxSliderValue)}

                        loadValue={this.getLoadValue(this.props.currentSliderValue)}
                        minValue={this.getMinValueForLoad()}
                        maxValue={this.getLoadValue(100)}
                    >
                        <div style={{ color: '#555555', fontSize: '25px', fontFamily: 'Montserrat, sans-serif' }}>
                            {this.getTextForProgressBar(this.getLoadValue(this.props.currentSliderValue))}
                        </div>
                        <div style={{ color: '#555555', fontSize: '18px', fontFamily: 'Montserrat, sans-serif' }}>{this.props.bodyWeightUnitString}</div>
                    </CustomTextProgressbar>
                </div>
            </div>
        );
    }
}

